import React from 'react';
import { Phone, Mail, MapPin, Clock, MessageSquare } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-sky-50/30">
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-4">
              We'll Fix It Right <span className="text-sky-500">the First Time</span>
            </h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              No do-overs needed — same-day repairs with lifetime warranty. Your device in expert hands, done right the first time around.
            </p>
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            
            {/* Left/Center - Contact Methods (2 columns) */}
            <div className="lg:col-span-2 space-y-6">
              
              {/* Primary Contact - Text, Call & Email (Large Cards) */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                
                {/* Text Message - Primary */}
                <a 
                  href="sms:+19782576427"
                  className="bg-gradient-to-br from-sky-500 to-sky-600 rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all hover:scale-[1.02] group"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                      <MessageSquare className="w-8 h-8 text-sky-600" />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">Text Us</h3>
                    <p className="text-sky-50 text-sm mb-4">(Fastest Response!)</p>
                    <p className="text-white font-semibold text-xl">(978) 257-6427</p>
                  </div>
                </a>

                {/* Phone Call - Primary */}
                <a 
                  href="tel:+19782576427"
                  className="bg-white border-2 border-sky-300 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:scale-[1.02] group"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-sky-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                      <Phone className="w-8 h-8 text-sky-600" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-4">Call Us</h3>
                    <p className="text-sky-600 font-semibold text-xl">(978) 257-6427</p>
                  </div>
                </a>

                {/* Email - Primary */}
                <a 
                  href="mailto:kyleperkinstech@gmail.com"
                  className="bg-white border-2 border-sky-300 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:scale-[1.02] group"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-sky-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                      <Mail className="w-8 h-8 text-sky-600" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-4">Email Technician</h3>
                    <p className="text-sky-600 font-semibold text-base break-all">kyleperkinstech@gmail.com</p>
                  </div>
                </a>
              </div>

              {/* Secondary Info - Location Full Width */}
              <div className="grid grid-cols-1 gap-6">
                
                {/* Hours */}
                <div className="bg-white rounded-xl p-6 shadow-md border border-slate-100">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Clock className="w-5 h-5 text-sky-600" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-slate-900 mb-1">Hours</h3>
                      <p className="text-slate-600 text-sm">Mon-Sat: 11am-10pm</p>
                      <p className="text-slate-600 text-sm">Sun: By Appt.</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Location - Simple Card */}
              <div className="bg-white rounded-xl p-6 shadow-md border border-slate-100">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5 text-sky-600" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-slate-900 mb-2">Visit Our Shop</h3>
                    <p className="text-slate-900 font-medium">22 Hammond Street, Concord, NH 03301</p>
                    <p className="text-sky-600 text-sm mt-2">📍 Right off I-93, Exit 13 - Easy highway access</p>
                  </div>
                </div>
              </div>

            </div>

            {/* Right - Your Photo (Clean, No Header) */}
            <div className="lg:col-span-1">
              <div className="rounded-2xl overflow-hidden shadow-2xl sticky top-24"
                   style={{
                     boxShadow: '0 25px 50px -12px rgba(71, 85, 105, 0.3)'
                   }}>
                <img
                  src="https://customer-assets-wrfwihn1.emergentagent.net/job_83cd0194-c314-4ffc-99ab-72d210cfce32/artifacts/5nvqquz0_IMG_1868.PNG"
                  alt="Apple Tech Guys NH"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
